export const getTokenUserRoles = (roles = []) => {
  return roles.map((role) => role.name);
};
